<template>
    <div class="main_center">
        <busWitnessTable :busWitnessTableType.sync="businessType"></busWitnessTable>
    </div>
</template>

<script>
import { mapState } from "vuex";
import busWitnessTable from './busWitnessTable';
export default {
    components: {
      busWitnessTable
    },
    data(){
        return{
            timer:false,
            user:'',
          businessType:"",
        }
    },
    activated(){

        this.businessType = this.$route.params.type?this.$route.params.type:"GT";
        window.sessionStorage.setItem("witnessFlowbusinessType",this.businessType)

    },
    created(){

        this.businessType = this.$route.params.type?this.$route.params.type:"GT";
        window.sessionStorage.setItem("witnessFlowbusinessType",this.businessType)

    },
    mounted() {

    },
    computed: {
        ...mapState({
            stateData:state=>state.user
        })
    },

    methods:{

    },
    filters:{

    },
    destroyed(){

    },
}
</script>

<style lang="less" scoped>
</style>